import { Toaster } from '@nu-art/toasting';
const ToastKey_LiveMDM = 'toast-key__live-mdm';
export const Toast_LiveMDM = new Toaster(ToastKey_LiveMDM, 1600);
export const ToastFilter_LiveMDM = (model) => model.key === ToastKey_LiveMDM;
//# sourceMappingURL=toast.js.map